/**
 * Pure math for the "Revenue Recovery Calculator" (ProfitEngineSection).
 * Extracted so it can be unit tested without mounting the component.
 */
export interface ProfitCalculatorInput {
  /** Total inbound calls per month */
  calls: number;
  /** Average job/ticket value in USD */
  jobValue: number;
  /** % of calls currently missed (0-100) */
  missedRate: number;
  /** % of recovered calls that convert to a booked job (0-100) */
  closeRate: number;
}

export interface ProfitCalculatorResult {
  missedCalls: number;
  revenueLost: number;
  recovered: number;
  annualSaved: number;
}

// Assumption, stated openly in the UI: Chleb AI recovers a share (not 100%) of
// currently-missed calls via instant answer + missed-call SMS. 70% is a
// conservative blended figure.
export const AI_RECOVERY_RATE = 0.7;

export function calculateProfitRecovery({
  calls,
  jobValue,
  missedRate,
  closeRate,
}: ProfitCalculatorInput): ProfitCalculatorResult {
  const missedCalls = Math.round(calls * (missedRate / 100));
  const revenueLost = Math.round(missedCalls * (closeRate / 100) * jobValue);
  const recovered = Math.round(revenueLost * AI_RECOVERY_RATE);
  const annualSaved = recovered * 12;
  return { missedCalls, revenueLost, recovered, annualSaved };
}
